/* GRADAZONE — capa de fondo: altura medida en pixeles reales, sin unidades de viewport.
 *
 * En iOS Safari vh/dvh/lvh no son fiables (la barra del navegador cambia el viewport y los
 * elementos fixed se dimensionan con el viewport pequeno), asi que aqui no se usa ninguna:
 *   - alto del CONTENEDOR = altura real del contenido del documento
 *   - alto de la IMAGEN    = altura real visible (visualViewport) x MARGEN
 *
 * IMPORTANTE (fondo estatico): NO se recalcula durante el scroll. Antes habia un listener
 * en visualViewport.scroll que disparaba un reflow en cada frame y hacia que la imagen
 * "temblara" al deslizar. Ahora solo se recalcula cuando cambia algo de verdad, y ademas
 * se comprueba antes de escribir para no tocar el DOM sin necesidad.
 */
(function () {
  var MARGEN = 1.18;   // se pasa de alto a proposito: cubrir de mas no cuesta nada
  var ultimoDoc = -1, ultimoImg = -1, pendiente = null;

  function altoVisible() {
    var vv = window.visualViewport;
    return Math.round(Math.max(
      vv ? vv.height : 0,
      window.innerHeight || 0,
      document.documentElement.clientHeight || 0
    ));
  }

  function altoContenido() {
    var d = document.documentElement, b = document.body;
    return Math.round(Math.max(
      d.scrollHeight, d.offsetHeight, d.clientHeight,
      b ? b.scrollHeight : 0, b ? b.offsetHeight : 0
    ));
  }

  function ajustar() {
    var capas = document.querySelectorAll('[data-gz-bg]');
    if (!capas.length) return;
    var hImg = Math.ceil(altoVisible() * MARGEN);
    var hDoc = altoContenido();
    // sin cambios reales -> no se toca el DOM (evita reflows y el temblor al scrollear)
    if (hDoc === ultimoDoc && hImg === ultimoImg) return;
    ultimoDoc = hDoc; ultimoImg = hImg;

    for (var i = 0; i < capas.length; i++) {
      var capa = capas[i];
      capa.style.height = hDoc + 'px';
      var pegado = capa.querySelector('.gz-bg__sticky');
      if (pegado) pegado.style.height = hImg + 'px';
      var imgs = capa.querySelectorAll('.gz-bg__img');
      for (var j = 0; j < imgs.length; j++) imgs[j].style.height = hImg + 'px';
    }
  }

  // se agrupa en un rAF: varios eventos seguidos = un solo recalculo
  function pedirAjuste() {
    if (pendiente) return;
    pendiente = requestAnimationFrame(function () { pendiente = null; ajustar(); });
  }

  window.GZ_ajustarFondo = ajustar;
  window.GZ_auditarFondo = function () {
    var capa = document.querySelector('[data-gz-bg]');
    if (!capa) return { ok: false, motivo: 'sin capa de fondo' };
    var hDoc = altoContenido();
    var r = capa.getBoundingClientRect();
    var img = capa.querySelector('.gz-bg__img');
    var esp = capa.querySelector('.gz-bg__img--espejo');
    return {
      alturaContenido: hDoc,
      alturaContenedorFondo: Math.round(r.height),
      cubreContenido: Math.round(r.height) >= hDoc - 1,
      alturaImagen: Math.round(img.getBoundingClientRect().height),
      alturaVisible: altoVisible(),
      tieneEspejoDeSeguridad: !!esp,
      cobertura: Math.round(img.getBoundingClientRect().height * (esp ? 2 : 1)) + 'px sobre ' + altoVisible() + 'px de pantalla',
    };
  };

  ajustar();
  document.addEventListener('DOMContentLoaded', pedirAjuste);
  window.addEventListener('load', pedirAjuste);
  window.addEventListener('resize', pedirAjuste, { passive: true });
  window.addEventListener('orientationchange', pedirAjuste, { passive: true });
  // solo 'resize' del visualViewport: 'scroll' provocaba el temblor
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', pedirAjuste, { passive: true });
  }
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(pedirAjuste);
    ro.observe(document.documentElement);
    if (document.body) ro.observe(document.body);
  }
})();
